import { INITIALIZE_FORM_EDIT_CREDIT } from '../actionTypes';
import { creditFileActions } from '../reducer';

export default (values) =>
    creditFileActions[INITIALIZE_FORM_EDIT_CREDIT](values);
